import React from "react";
import CaseStudyPage from "../../components/CaseStudyPage";
import { caseStudies } from "../../data/projects";

export default function TherapEase() {
  const project = caseStudies.find((p) => p.slug === "therapease");
  const currentIndex = caseStudies.findIndex((p) => p.slug === "therapease");
  const nextProject = caseStudies[(currentIndex + 1) % caseStudies.length];

  return <CaseStudyPage project={project} nextProject={nextProject} />;
}
